import { createFileRoute, redirect } from '@tanstack/react-router'

// Продукт отвечает на один вопрос — кто когда занят, поэтому корень ведёт прямо
// в расписание, а не на промежуточную главную.
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/schedule' })
  },
})
